import Api from '@/services/Api'

const URL = 'cxc/corte-caja-tienda/';

export default {

    fetch(_params) {
        return Api().get(URL, {
            params: _params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },

    fetchModule(module,path, params){
        let url = module + '/' + path + '/'
        return Api().get(url,{params:params})
    },

    getAction(id,action,params) {
        return Api().post(URL + id + "/" + action + "/",params)
    },

    getActionList(action,params) {
        return Api().get(URL + action + "/",params)
    },
    postActionList(action,params) {
        return Api().post(URL + action + "/",params)
    },
}